import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';


export const ChangePasswordForm = ({ onChangePasswordSuccess }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    
    
    const handleCurrentPasswordChange = (value) => {
        setCurrentPassword(value);
    };

    const handleNewPasswordChange = (value) => {
        setNewPassword(value);
    };

    const handleConfirmPasswordChange = (value) => {
        setConfirmPassword(value);
    };

    const handlePasswordChangeProcess = () => {
        // Add validation logic for password requirements, e.g., length, complexity, etc.
        if (newPassword.length < 6) {
            setPasswordError(true);
            return;
        }

        const changePasswordData = {
            CurrentPassword: currentPassword,
            NewPassword: newPassword,
            ConfirmPassword: confirmPassword,
        };

        const url = 'https://localhost:7151/api/UserAccount/ChangePassword';

        axios
            .post(url, changePasswordData)
            .then((result) => {
                alert(result.data);
                onChangePasswordSuccess();
            })
            .catch((error) => {
                alert(error);
            });
    };

    return (
        <div className="auth-form d-flex align-items-center justify-content-center" style={{ marginTop: '2rem' }}>
            <div className="col-md-6" style={{ maxWidth: '450px', maxHeight: '960px' }}>
                <div className="card border-0 shadow">
                    <div className="card-header bg-primary text-white text-center">
                        <h3>Change Password</h3>
                    </div>
                    <div className="card-body">
                        <div className="mb-3">
                            <label htmlFor="currentPassword" className="form-label">
                                Current Password
                            </label>
                            <input
                                type="password"
                                className="form-control"
                                id="currentPassword"
                                placeholder="Enter current password"
                                onChange={(e) => handleCurrentPasswordChange(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="newPassword" className="form-label">
                                New Password
                            </label>
                            <input
                                type="password"
                                className={`form-control ${passwordError ? 'is-invalid' : ''}`}
                                id="newPassword"
                                placeholder="Enter new password"
                                onChange={(e) => handleNewPasswordChange(e.target.value)}
                                required
                            />
                            {passwordError && (
                                <div className="invalid-feedback">Password should be at least 6 characters.</div>
                            )}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="confirmPassword" className="form-label">
                                Confirm Password
                            </label>
                            <input
                                type="password"
                                className="form-control"
                                id="confirmPassword"
                                placeholder="Confirm new password"
                                onChange={(e) => handleConfirmPasswordChange(e.target.value)}
                                required
                            />
                        </div>
                        <div className="d-grid gap-2">
                            <button
                                className="btn btn-primary btn-lg"
                                type="submit"
                                onClick={() => handlePasswordChangeProcess()}
                            >
                                Change Password
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


